import { render, staticRenderFns } from "./teachingDetails.vue?vue&type=template&id=3fae856d"
import script from "./teachingDetails.vue?vue&type=script&lang=js"
export * from "./teachingDetails.vue?vue&type=script&lang=js"
import style0 from "./teachingDetails.vue?vue&type=style&index=0&id=3fae856d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports